import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  message,
  Input,
  Tabs,
  Button,
  Table,
  Modal,
  Spin,
  Typography,
} from "antd";
import { PlusOutlined, SearchOutlined, EditOutlined } from "@ant-design/icons";
import VehicleTypesForm from "./vehicleTypesForm";
import axios from "axios";

const { Search } = Input;
const { Title } = Typography;

const VehicleTypes = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [filteredVehicleTypes, setFilteredVehicleTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchVehicleTypes();
  }, []);

  const fetchVehicleTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/vehicleTypes");
      setVehicleTypes(response.data);
      setFilteredVehicleTypes(response.data);
    } catch (error) {
      message.error("Unable to load vehicle types");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    const filteredData = vehicleTypes.filter((type) =>
      Object.keys(type).some((key) =>
        String(type[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredVehicleTypes(filteredData);
  };

  const handleAddVehicleType = () => {
    setFormData({});
    setModalVisible(true);
  };

  const handleEditVehicleType = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const columns = [
    {
      title: "Type Name",
      dataIndex: "typeName",
      key: "typeName",
      render: (text) => (
        <span style={{ fontWeight: "bold" }}>{text || "N/A"}</span>
      ),
    },
    {
      title: "Price Per KM",
      dataIndex: "pricePerKM",
      key: "pricePerKM",
      render: (text) => `$${text || "N/A"}`,
    },
    {
      title: "Surge Price Per KM",
      dataIndex: "surgePricePerKM",
      key: "surgePricePerKM",
      render: (text) => `$${text || "N/A"}`,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditVehicleType(record)}
          style={{ color: "#0c8c49" }}
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Vehicle Types
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Search
              placeholder="Search Vehicle Types"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddVehicleType}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Vehicle Type
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={filteredVehicleTypes}
            pagination={{ pageSize: 5 }}
            rowKey="id"
            bordered
          />
        )}
      </Card>

      <Modal
        title={formData.id ? "Edit Vehicle Type" : "Add Vehicle Type"}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <VehicleTypesForm
          formData={formData}
          setFormData={setFormData}
          closeModal={() => setModalVisible(false)}
          setSubmitted={() => fetchVehicleTypes()} // Refetch data on form submission
        />
      </Modal>
    </div>
  );
};

export default VehicleTypes;
